module.exports = __webpack_public_path__ + "img/fapiao1.cee83324.png";